import React from 'react';
import Payment from 'organisms/Payment/container/Payment';

const PaymentFailedView = props => {
  const { paymentDetails, updatePaymentDetails } = props;

  return paymentDetails?.tenantId && paymentDetails?.basketId && paymentDetails?.customerId && paymentDetails?.allowedTenders && <Payment {...props} checkoutDetails={paymentDetails} updateCheckoutDetails={updatePaymentDetails} />;
};

export default React.memo(PaymentFailedView);
